import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

export default function TeamAuthReturn() {
  const navigate = useNavigate();
  useEffect(() => {
    const restore = () => {
      const target = sessionStorage.getItem('circlo-auth-return');
      if (target === '/marketing/competitors') { sessionStorage.removeItem('circlo-auth-return'); navigate(target, { replace: true }); }
    };
    const { data } = supabase.auth.onAuthStateChange((event, session) => { if (event === 'SIGNED_IN' && session) restore(); });
    void supabase.auth.getSession().then(({ data }) => { if (data.session) restore(); });
    return () => data.subscription.unsubscribe();
  }, [navigate]);
  return null;
}